<template>
  <div class="ms-form">
    <q-form @submit="this.onSubmit">
      <p v-if="this.formLoading" class="ms-empty">Загрузка…</p>
      <p v-else-if="this.error" class="ms-empty multiple-invoice__error">{{ this.error }}</p>
      <div v-else class="ms-form-grid">
        <dl class="ms-kv ms-form-wide">
          <div class="ms-kv__row">
            <dt>Выбрано заявок</dt>
            <dd>{{ this.providerRequestIds.length }}</dd>
          </div>
          <div class="ms-kv__row">
            <dt>Общая сумма факта</dt>
            <dd><Amount :value="this.factSum" /></dd>
          </div>
        </dl>

        <CustomSelect
          :options="this.documentTypeOptions"
          label="Тип документа"
          :required="true"
          optionValueKey="value"
          optionLabelKey="label"
          :value="this.formData.invoice_type_id || ''"
          @change="(value) => onChange('invoice_type_id', value)"
        />

        <CustomInput
          label="Номер документа"
          :value="this.formData.invoice_num"
          @change_input="(value) => onChange('invoice_num', value)"
          :required="true"
        />

        <CustomDate
          :fullWidth="true"
          label="Дата документа"
          :value="this.formData.invoice_date"
          @change_date="(value) => onChange('invoice_date', value)"
          :required="true"
        />

        <div>
          <div class="ms-form-label">Организация накладной</div>
          <div class="ms-seg">
            <button
              v-for="opt in this.orgOptions"
              :key="opt.value"
              type="button"
              :class="{ active: this.formData.org_bin_id === opt.value }"
              @click="onChange('org_bin_id', opt.value)"
            >
              {{ opt.label }}
            </button>
          </div>
        </div>

        <CustomSelect
          v-if="this.formData.invoice_type_id === 3"
          class="ms-form-wide"
          :options="this.invoiceOptions"
          label="Основная накладная"
          :required="true"
          optionValueKey="provider_request_invoice_id"
          optionLabelKey="label"
          :value="this.formData.main_provider_request_invoice_id || ''"
          @change="(value) => onChange('main_provider_request_invoice_id', value)"
        />
      </div>

      <CustomModalFooter
        :btn-loading="this.loading"
        :hideSubmitBtn="this.formLoading || !!this.error"
      />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomDate from "@/components/form/CustomDate";
import Amount from "@/components/common/Amount";
import { getMultipleInvoiceForm } from "@/views/ProviderRequests/services";

export default {
  name: "provider-requests-multiple-invoice",
  components: { CustomModalFooter, CustomInput, CustomSelect, CustomDate, Amount },
  props: ["data"],
  data() {
    return {
      loading: false,
      formLoading: true,
      error: "",
      factSum: 0,
      invoices: [],
      formData: {
        invoice_type_id: "",
        invoice_num: "",
        invoice_date: "",
        org_bin_id: 1,
        main_provider_request_invoice_id: "",
      },
      documentTypeOptions: [
        { label: "Накладная", value: 1 },
        { label: "АВР", value: 2 },
        { label: "Доп. услуга к накладной", value: 3 },
      ],
      orgOptions: [
        { label: "Smart Remont", value: 1 },
        { label: "ТОО Smart Fulfillment", value: 3 },
      ],
    };
  },
  computed: {
    providerRequestIds() {
      return this.data?.body?.provider_request_id_arr || [];
    },
    invoiceOptions() {
      return this.invoices.map((row) => ({
        ...row,
        label: `Накладная №${row.invoice_num} от ${row.invoice_date}`,
      }));
    },
  },
  async created() {
    const res = await getMultipleInvoiceForm(this.providerRequestIds);
    this.formLoading = false;
    if (res.error) {
      this.error = res.error;
      return;
    }
    this.factSum = res.data.fact_sum || 0;
    this.invoices = res.data.invoices || [];
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      await this.data?.onSubmit({
        ...this.formData,
        provider_request_id_arr: this.providerRequestIds,
      });
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.multiple-invoice__error {
  color: var(--ms-danger);
}
</style>
